export class DistributionModeFilter {
    public IncludeInactive?: boolean;
}

export default DistributionModeFilter;